import {type Dispatch, type FC, type KeyboardEvent, type SetStateAction} from 'react';
import {
  FormSelectionEnum,
  type methodType,
  inputMenuActionType,
  type InputMenuAction,
  type ModalDialogProps,
} from 'interfaces';

import forms from 'components/InputMenu';
import TransferModal from './TransferModal';
import {type TFunction} from 'i18next';
import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

export const rightDrawerMenuHandler = (
  form: FormSelectionEnum,
  method: methodType,
  t: TFunction,
  flags?: LDFlagSet,
) => {
  const title = `${t(method)} ${t(form).toLowerCase()}`;
  switch (form) {
    case FormSelectionEnum.plan:
      return {
        title,
        component: () => <forms.Plan />,
      };
    case FormSelectionEnum.site:
      return {
        title,
        component: () => <forms.Site />,
      };
    case FormSelectionEnum.cage:
      return {
        title,
        component: () => <forms.Cage />,
      };
    case FormSelectionEnum.fallowing:
      return {
        title,
        component: () => <forms.SiteFallowing />,
      };
    case FormSelectionEnum.input:
      return {
        title,
        component: () => <forms.CageInput />,
      };
    case FormSelectionEnum.harvest:
      return {
        title,
        component: () => <forms.CageHarvest />,
      };
    case FormSelectionEnum.emergencyHarvest:
      return {
        title,
        component: () => <forms.CageHarvest emergencyHarvest={true} />,
      };
    case FormSelectionEnum.concession:
      return {
        title,
        component: () => <forms.Concession />,
      };
    case FormSelectionEnum.growthModel:
      return {
        title,
        component: () => <forms.GrowthModel />,
      };
    case FormSelectionEnum.fishType:
      return {
        title,
        component: () => <forms.FishType />,
      };
    case FormSelectionEnum.siteGrowthModel:
      return {
        title: `${t(method)} ${t('siteAssignment').toLowerCase()}`,
        component: () => <forms.SiteGrowthModelOverride />,
      };
    case FormSelectionEnum.smoltAvailability:
      return {
        title,
        component: () => <forms.SmoltAvailability />,
      };
    case FormSelectionEnum.harvestDemand:
      return {
        title,
        component: () => <forms.HarvestDemand />,
      };
    case FormSelectionEnum.liveFishTransaction:
      return {
        title,
        component: () => <forms.LiveFishTransactionsForm />,
      };
    case FormSelectionEnum.notFallowing:
      return undefined;
    case FormSelectionEnum.delousing:
      return {
        title,
        component: () => <forms.DelousingInputMenu />,
      };
    case FormSelectionEnum.fishGroup:
      return {
        title,
        component: () => <forms.FishGroupMenu />,
      };
    case FormSelectionEnum.company:
      return {
        title,
        component: () => <forms.CompanyMenu />,
      };
  }
};

export const handleKeyDown = (
  inputMenuDispatch: Dispatch<InputMenuAction>,
  event: KeyboardEvent<HTMLDivElement>,
  setCreateUpdate: Dispatch<SetStateAction<boolean>> | (() => void),
) => {
  if (event.key === 'Enter') {
    setCreateUpdate(true);
  }
  if (event.key === 'Escape') {
    inputMenuDispatch({type: inputMenuActionType.closeMenu});
  }
};

/**
 * @deprecated DO NOT EXTEND! use useModalWindow hook instead
 */
export const ModalComponentsMap = new Map<FormSelectionEnum, FC<ModalDialogProps<any, any>>>([
  [FormSelectionEnum.transfer, TransferModal],
  [FormSelectionEnum.transferIn, TransferModal],
  [FormSelectionEnum.transferOut, TransferModal],
]);
